"use client";

import { createContext, useContext } from "react";
import { useAssemblyStreaming } from "@/hooks/useAssemblyStreaming";

const AssemblyContext = createContext(null);

export function AssemblyContextProvider({ children, ...options }) {
  const streaming = useAssemblyStreaming(options);
  return <AssemblyContext.Provider value={streaming}>{children}</AssemblyContext.Provider>;
}

export function useAssembly() {
  const value = useContext(AssemblyContext);
  if (!value) throw new Error("useAssembly must be used within an AssemblyContextProvider");
  return value;
}
